import * as utilities from '#utilities/js/styles.js'

export default page => {
  const { ownerDocument } = page
  const { body } = ownerDocument
  body.classList.add(utilities.modifiers.overflow.hidden)
}